<div class="header-wrapper">
  <mat-toolbar>
    <mat-toolbar-row class="primary-toolbar">
      <button
        matIconButton
        type="button"
        (click)="hamburgerRequested.emit()"
        aria-label="Show Navigation"
        class="hamburger"
      >
        <mat-icon class="material-symbols-outlined">menu</mat-icon>
      </button>

      @if (configData() && logoImgInfo()) {
        <a [routerLink]="['']" class="logo-link">
          <img [src]="logoImgInfo().src" [alt]="logoImgInfo().alt" class="logo" />
        </a>
      }

      <span class="toolbar-spacer"></span>

      <div class="utility-nav">
        @if (userSignal() && orgConfigData()) {
          <img
            class="user-organization-logo"
            [src]="orgConfigData()?.login_tile_logo"
            [alt]="userSignal()?.organization.full_name"
          />
          <button
            matIconButton
            type="button"
            [matMenuTriggerFor]="loggedInMenu"
            aria-label="User Profile"
            (focus)="trigger?.openMenu()"
            tabIndex="0"
          >
            <mat-icon class="material-symbols-outlined">account_circle</mat-icon>
          </button>
          <mat-menu #loggedInMenu="matMenu" [classList]="'logged-in-menu'">
            <div mat-menu-item disabled class="name">{{ userSignal().display_name }}</div>
            <div mat-menu-item disabled class="session" [class.session-warning]="tokenValidityPeriodLow">
              <div class="subtitle">Session ends in:</div>
              <div class="clock">{{ tokenValidityPeriod | timeLeft }}</div>
            </div>
            <button mat-menu-item type="button" class="logout" routerLink="/logout" tabIndex="1">
              <mat-icon class="material-symbols-outlined">logout</mat-icon>
              Log Out
            </button>
          </mat-menu>
        }

        @if (!userSignal()) {
          <a mat-button type="button" routerLink="/login">
            <mat-icon class="material-symbols-outlined">login</mat-icon>
            Log In
          </a>
        }
      </div>
    </mat-toolbar-row>

    @if (showSectionHeader() && (sectionTitle() || !!sectionHeaderActions()?.length)) {
      <mat-toolbar-row class="secondary-toolbar">
        <h1 class="section-title">
          @if (showSectionShield()) {
            <mat-icon class="material-symbols-outlined">security</mat-icon>
          }
          <a [href]="sectionUrl()" class="visited-color-mask undecorated">{{ sectionTitle() }}</a>
        </h1>
        <span class="toolbar-spacer"></span>
        <div class="actions">
          @for (btn of sectionHeaderActions(); track btn.caption) {
            @if (btn.onClick && btn.icon === 'file_download') {
              <a
                mat-button
                #buttonElement
                [style.color]="btn.color"
                (click)="btn.onClick($event, buttonElement)"
                type="button"
              >
                @if (btn.loading) {
                  <mat-icon class="material-symbols-outlined spinning"> progress_activity </mat-icon>
                } @else {
                  <mat-icon class="material-symbols-outlined">
                    {{ btn.icon }}
                  </mat-icon>
                }
                <span class="caption">{{ btn.caption }}</span>
              </a>
            } @else {
              <a
                mat-button
                [style.color]="btn.color"
                [routerLink]="btn.target"
                [attr.aria-label]="btn.ariaLabel"
                [target]="btn.targetTab ? btn.targetTab : '_self'"
              >
                <mat-icon class="material-symbols-outlined">
                  {{ btn.icon }}
                </mat-icon>
                <span class="caption">{{ btn.caption }}</span>
              </a>
            }
          }
        </div>
      </mat-toolbar-row>
    }

    @if (!userSignal() && isSearchPage()) {
      <mat-toolbar-row class="guest-reminder">
        <div>
          <mat-icon class="material-symbols-outlined">person</mat-icon>
          You are browsing as a guest.
          <a [routerLink]="['login']">Log in</a> to unlock all features and private&nbsp;content.
        </div>
      </mat-toolbar-row>
    }

    @if (userSignal() && tokenValidityPeriodLow) {
      <mat-toolbar-row class="session-warning">
        <div>
          <mat-icon class="material-symbols-outlined">hourglass_bottom</mat-icon>
          @if (tokenValidityPeriod <= 0) {
            Your session has expired. To save your work, open a new tab and log in. Then copy your work from this tab to
            the new one.
          } @else {
            Your session will end in {{ tokenValidityPeriod | timeLeft }}. Please save your work.
          }
        </div>
      </mat-toolbar-row>
    }
  </mat-toolbar>
</div>
